export enum MediaTypes {
  JSON = 'application/json',
  XML = 'application/xml',
}

export enum NavItemTypes {
  MAIN = 'NavTypes.Main',
  META = 'NavTypes.Meta',
  FOOTER = 'NavTypes.Footer',
  SOCIAL_MEDIA = 'NavTypes.SocialMedia',
  EMAIL = 'NavTypes.Email',
}
